import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Observable } from 'rxjs';
import { IS_SERVER_PLATFORM, UserRole, UserRoles, UserService } from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(
    private userService: UserService,
    private router: Router,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean
  ) {}

  async canActivate(route: ActivatedRouteSnapshot,): Promise<boolean | UrlTree> {
    try {
      if (this.isServer) return false;
      if (!!!this.isServer) {
        const user = await JSON.parse(localStorage.getItem('user') || '');
        if (user && user.role) {
          if (user.role.code === UserRoles.ADMIN) return true;
          else {
            this.router.navigate(['/']);
            return false;

          }
        }
      }
      this.router.navigate(['/']);
      return false;

      // const user = await this.userService.getUser(true);

      // if (user.role && user.role.code === UserRoles.ADMIN) {
      //   return true;
      // }
    } catch (e) {
      return false;
    }
  }
}
